import { OrganoJudicial as IOrganoJudicial } from 'src/interfaces'

type Props = {
  organoJudicial: IOrganoJudicial
}

function OrganoJudicial({ organoJudicial }: Props): JSX.Element {
  return (
    <div>
      <div>
        <strong>Órgano: </strong>
        <span>
          {organoJudicial.nombre} ({organoJudicial.codigoConsejo})
        </span>
      </div>
      {organoJudicial.tipoOrgano && (
        <div>
          <strong>Tipo de Órgano:</strong>
          <span>{organoJudicial.tipoOrgano}</span>
        </div>
      )}
    </div>
  )
}

export default OrganoJudicial
